<template>
  <div>
    <CrudList
      title="Especialidades"
      storeName="Specialities"
      labelAddNew="Agregar nueva Especialidad"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
    >
      <template v-slot:appointmentPrices="{item}">
        <v-btn
            class="my-2"
            color="primary"
            @click="$router.push('/admin/specialities/' + item.id + '/appointment_prices')"
        >Precios de consultas
        </v-btn>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
  };
</script>
